/**
 * Created by spepa on 05.04.2023
 */

const InstantTournament = function () {
    this.id = undefined;

    this.load();

    if (connector.platform.isConnected()) {
        this.updateId();
    }

    connector.platform.on("changeStatus", (status) => {
        if (status === connector.STATUS_CONNECTED) {
            this.updateId();
        }
    });
};

InstantTournament.prototype.updateId = function () {
    if (!this.isAvailable()) {
        return;
    }

    cleverapps.platformLogic.getCurrentTournamentId((code, id) => {
        if (code !== cleverapps.CODE_SUCCEED) {
            return;
        }

        if (id !== this.id) {
            this.id = id;
            this.save();
        }
    });
};

InstantTournament.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.INSTANT_TOURNAMENT);
    if (data) {
        this.id = data.id;
    }
};

InstantTournament.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.INSTANT_TOURNAMENT, {
        id: this.id
    });
};

InstantTournament.prototype.isInTournament = function () {
    return this.id !== undefined;
};

InstantTournament.prototype.isAvailable = function () {
    return cleverapps.platformLogic.getCurrentTournamentId;
};

InstantTournament.prototype.reportScore = cleverapps.accumulate(1000, function () {
    if (!cleverapps.scoreTracker.needToReport()) {
        return;
    }

    if (!connector.platform.isConnected()) {
        return;
    }

    cleverapps.platformLogic.getCurrentTournamentId((code, id) => {
        if (code !== cleverapps.CODE_SUCCEED) {
            return;
        }

        if (this.id !== id) {
            this.id = id;
            this.save();
        }

        if (this.id) {
            cleverapps.scoreTracker.report();
        }
    });
});

InstantTournament.REPORT_TIMEOUT = 600000;

if (["merge", "merge2"].includes(cleverapps.config.type)) {
    InstantTournament.REPORT_TIMEOUT = cleverapps.parseInterval("2 days");
}